import React, { useState, useEffect } from 'react';
import { collection, addDoc, serverTimestamp, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import './CustomerReview.css';
import { useTranslation } from 'react-i18next';
import { reviewFormText } from '../constants/reviewFormText';

const CustomerReview = ({ customerId, coffeeShopId, customerName }) => {
  const { t } = useTranslation();
  const [rating, setRating] = useState('');
  const [feeling, setFeeling] = useState('');
  const [staffExperience, setStaffExperience] = useState('');
  const [employeeInteraction, setEmployeeInteraction] = useState('');
  const [comment, setComment] = useState('');
  const [message, setMessage] = useState('');
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState('');

  useEffect(() => {
    const fetchEmployees = async () => {
      const q = query(collection(db, 'employees'), where('coffee_shop_id', '==', coffeeShopId));
      const querySnapshot = await getDocs(q);
      setEmployees(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchEmployees();
  }, [coffeeShopId]);

  const submitReview = async () => {
    if (!rating || !feeling || !staffExperience || !selectedEmployee) {
      setMessage(t('review_fill_all_fields'));
      return;
    }

    try {
      await addDoc(collection(db, 'reviews'), {
        customer_id: customerId,
        coffee_shop_id: coffeeShopId,
        rating,
        feeling,
        staff_experience: staffExperience,
        employee_name: selectedEmployee,
        comment,
        timestamp: serverTimestamp(),
      });

      setMessage(t('review_success'));
      setRating('');
      setFeeling('');
      setStaffExperience('');
      setSelectedEmployee('');
      setComment('');
    } catch (error) {
      setMessage(t('review_error') + ': ' + error.message);
    }
  };

  return (
    <div className="review-container">
      <h3 className="review-title">{t('leave_review')}</h3>

      <select value={rating} onChange={(e) => setRating(e.target.value)} required>
        <option value="">{t('review_select_rating')}</option>
        <option value="bad">😞 {t('review_rating_bad')}</option>
        <option value="good">🙂 {t('review_rating_good')}</option>
        <option value="very good">😊 {t('review_rating_very_good')}</option>
        <option value="excellent">🌟 {t('review_rating_excellent')}</option>
      </select>

      <select value={feeling} onChange={(e) => setFeeling(e.target.value)} required>
        <option value="">{t('review_select_feeling')}</option>
        <option value="positive">😄 {t('review_feeling_positive')}</option>
        <option value="negative">😠 {t('review_feeling_negative')}</option>
        <option value="neutral">😐 {t('review_feeling_neutral')}</option>
      </select>

      <select value={staffExperience} onChange={(e) => setStaffExperience(e.target.value)} required>
        <option value="">{t('review_select_staff_experience')}</option>
        <option value="no">👍 {t('review_staff_experience_no')}</option>
        <option value="yes">👎 {t('review_staff_experience_yes')}</option>
      </select>

      <select value={selectedEmployee} onChange={(e) => setSelectedEmployee(e.target.value)} required>
        <option value="">{t('review_select_employee')}</option>
        {employees.map(emp => (
          <option key={emp.id} value={emp.name}>{emp.name}</option>
        ))}
      </select>

      <textarea
        placeholder={t('review_comment_placeholder')}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      ></textarea>

      <button className="submit-btn" onClick={submitReview}>
        {t('review_submit_button')}
      </button>

      {message && <div className="review-message">{message}</div>}
    </div>
  );
};

export default CustomerReview;